import { initializeApp } from 'firebase/app';
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration
// Replace these values with your Firebase project credentials
export const firebaseConfig = {
  apiKey: "AIzaSyA71ksa58Mp7l3qG2ifYIuAdJPzySfH2Ks",
  authDomain: "amalerp-29324.firebaseapp.com",
  projectId: "amalerp-29324",
  storageBucket: "amalerp-29324.firebasestorage.app",
  messagingSenderId: "521550129470",
  appId: "1:521550129470:web:6082000453b782fff2e46f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ─── Firestore database id ──────────────────────────────────────────────────
// Migrated 2026-08-04 from the '(default)' database (nam5, United States
// multi-region) to 'amalerp-2' (asia-south1, Mumbai): far closer to our users
// in Pakistan, and half the read price ($0.03 vs $0.06 per 100k).
//
// TO ROLL BACK: set this to '(default)', rebuild, redeploy — and roll the
// server side back too (functions/index.js, functions/whatsappService.js,
// whatsapp-service/server.js). The old database is left untouched, so no data
// restore is needed. See DB_CUTOVER_RUNBOOK.md.
//
// ⚠️ The server must be switched FIRST. If the app writes to Mumbai while the
// Cloud Function triggers still watch the old database, those triggers never
// fire — dashboards freeze and emails stop, with no error anywhere.
export const FIRESTORE_DB_ID = 'amalerp-2';

// Initialize Firebase services.
// Auth uses initializeAuth() with explicit persistence so the login session is
// guaranteed saved at construction time — no race with React useEffects.
//
// Persistence priority:
//   1. indexedDBLocalPersistence — survives browser restarts, shared across
//      tabs via BroadcastChannel (preferred — fixes "new tab logs out old tab")
//   2. browserLocalPersistence (localStorage) — fallback for browsers/modes
//      where IndexedDB is unavailable (e.g. some private modes)
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence]
});

// Firestore with offline persistence enabled.
//
// Why: every read your code makes (AuthContext fetching userProfile / company
// / financialYears / branches, POS preload, reports, etc.) is automatically
// cached in IndexedDB after the first successful online fetch. The same
// reads succeed offline using the cache — that's what makes "auto-login when
// offline" actually work end-to-end.
//
// `persistentMultipleTabManager` lets multiple browser tabs share one cache
// instead of fighting over it. Required for "open POS in 2 tabs" not to break.
//
// First-ever offline open of a fresh install will still fail (nothing cached
// yet). That's a real constraint — initial setup needs internet.
// NOTE: the offline cache is keyed per database id, so changing FIRESTORE_DB_ID
// invalidates every device's local cache once — expect a one-off read spike on
// the first open after cutover, then it settles.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
}, FIRESTORE_DB_ID);

export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
